import {
  allowedCorsOrigin,
  createContactProxyHandlers,
  enforceRateLimit,
  resetContactProxyRateLimitState,
} from "@server/contact-proxy"
import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

const contactProxyHandlers = createContactProxyHandlers()

export { allowedCorsOrigin, enforceRateLimit }
export const resetRateLimitState = resetContactProxyRateLimitState

export const Route = createFileRoute("/api/")(
  serverRouteConfig({
    server: {
      handlers: contactProxyHandlers,
    },
  })
)
